import React, { useState, useEffect } from 'react';
import KassaTransactionModal from './KassaTransactionModal';
import KassaService from '../../services/KassaService';
import TransportService from '../../services/TransportService';
import KassaChiqimService from '../../services/KassaChiqimService';
import { toast } from 'react-toastify';

const KassaExpenseModal = ({ show, onHide, editing = false, initialData = {}, refreshData = () => {} }) => {
  const [kassas, setKassas] = useState([]);
  const [transports, setTransports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (show) {
      fetchData();
    }
  }, [show]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const [kassaRes, transportRes] = await Promise.all([
        KassaService.getKassaList(),
        TransportService.getTransportList()
      ]);
      setKassas(kassaRes.data || []);
      setTransports(transportRes.data || []);
    } catch (err) {
      console.error('Error fetching data:', err);
      setError('Ma\'lumotlarni yuklashda xatolik yuz berdi');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (data) => {
    try {
      setLoading(true);
      
      if (editing && initialData.id) {
        await KassaChiqimService.updateKassaChiqim(data, initialData.id);
        toast.success('Kassa chiqimi muvaffaqiyatli yangilandi');
        refreshData();
      } else {
        await KassaChiqimService.createKassaChiqim(data);
        toast.success('Kassa chiqimi muvaffaqiyatli qo\'shildi');
      }
      
      onHide(true); // true means success
    } catch (err) {
      console.error('Error saving kassa chiqim:', err);
      setError(err.message || 'Xatolik yuz berdi. Iltimos qaytadan urinib ko\'ring.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <KassaTransactionModal
      show={show}
      onHide={() => onHide(false)}
      title={editing ? 'Kassa Chiqimini Tahrirlash' : 'Yangi Kassa Chiqimi'}
      kassas={kassas}
      transports={transports}
      onSubmit={handleSubmit}
      loading={loading}
      error={error}
      initialData={initialData}
      isExpense={true}
      editing={editing}
    />
  );
};

export default KassaExpenseModal;
